import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { forkJoin, Observable, Subscription } from 'rxjs';
import { filter, map, mergeMap, tap, switchMap } from 'rxjs/operators';
import { ModalInfoComponent } from "../ag-grid/modal-info.component";
import { AuthService } from "../../../services/auth.service";

import { RouterLinkRendererComponent } from '../ag-grid/router-link-renderer.component';
import { dateComparator } from '../data-table/comparators/data-table.comparators';

import { FinancialAssuranceService } from '../../services/financial-assurance.service';
import { GridFormatterService } from '../../services/grid-formatter.service';
import { WorkOrderService } from '../../services/work-order.service';

import { PendingFlow } from '../../../flow/models/flow.model';
import { WorkOrderStatus, WorkOrderType } from '../../models/work-order.model';
import { WorkOrderSearchSpec } from '../../../models/work-order-search-spec.model';

import { ContactStub } from "../../../admin/models/contact.model";
import { Group } from "../../../admin/models/group.model";
import { GroupSearchSpec, GroupService } from "../../../admin/services/group.service";
import { ActionCellRendererComponent } from "../../../common/components/ag-grid/action-cell-renderer.component";
import { FlowIndex } from '../../../common/models/flow.dto';
import { PendingWorkOrderAssignment } from '../../../common/models/work-order.model';
import { FlowInstanceService } from '../../../flow/services/flow-instance.service';
import { LunaClaimValues } from '../../../models/user-identity.model';
import { ViewBase } from "../../../dashboard/components/widgets/view-base";
import { OrganizationStub, OrganizationComplianceDetails } from '../../models/organization.model';


@Component({
    selector: 'fa-pending',
    templateUrl: './fa-pending.component.html',
    standalone: false
})
export class FinancialAssurancePendingComponent extends ViewBase implements OnInit {
    @Input() complianceData: OrganizationComplianceDetails[];
    @Input() isInternal: boolean = false;
    @Input() orgId: string;
    @Input() gridAriaLabel: string;
    subscriptions: Subscription = new Subscription();

    allUsers: ContactStub[] = [];
    groups: Group[] = [];
    filteredUsers: ContactStub[] = [];
    groupHasPermission: any;
    pendingAssignments: PendingWorkOrderAssignment[] = [];

    selectedItem: any;
    showingDetail: boolean = false;
    orgStubs: OrganizationStub[];


    columnExternalApplicationNumber: ColDef = {
        headerClass: "wrapped",
        headerName: 'Application Number',
        headerTooltip: 'Application Number',
        field: 'applicationNumber',
        tooltipField: 'applicationNumber',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 130
    };

    columnInternalApplicationNumber: ColDef = {
        headerClass: "wrapped",
        headerName: "Application Number",
        headerTooltip: "Application Number",
        field: "applicationNumber",
        tooltipField: "applicationNumber",
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams, 
        minWidth: 130,
        maxWidth: 130,
        cellRendererSelector: (params) => {
            if (this.canApprove(params)) {
                return {
                    component: RouterLinkRendererComponent,
                    params: { textField: "applicationNumber" }
                }
            } else {
                return {
                    component: ModalInfoComponent,
                    params: {
                        text: (params) => {
                            return params.applicationNumber;
                        },
                        modalText: (params) => {
                            return "You do not have permission to view or approve this application.";
                        }
                    }
                }
            }
        }
    }

    columnCompany: ColDef = {
        headerClass: "wrapped",
        headerName: 'Company',
        headerTooltip: 'Company',
        field: 'companyName',
        tooltipField: 'companyName',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
        minWidth: 130
    };

    columnCreatedBy: ColDef = {
        headerClass: "wrapped",
        headerName: 'Created By',
        headerTooltip: 'Created By',
        field: 'userName',
        tooltipField: 'userName',
        filter: "agTextColumnFilter",
        filterParams: this.formatterService.defaultTextFilterParams,
    };

    columnDateSubmitted: ColDef = {
        headerClass: "wrapped",
        headerName: 'Date Submitted',
        headerTooltip: 'Date Submitted',
        field: 'dateSubmitted',
        tooltipValueGetter: this.formatterService.formatDate('dateSubmitted'),
        valueGetter: this.formatterService.formatDate('dateSubmitted'),
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        filterParams: this.formatterService.defaultDateFilterParams,
        maxWidth: 150,
        minWidth: 145
    };

    columnFlowName: ColDef = {
        headerClass: "wrapped",
        headerName: 'Type',
        headerTooltip: 'Type',
        field: 'name',
        tooltipField: 'name',
        maxWidth: 125,
        minWidth: 125
    };

    columnFlowLink: ColDef = {
        headerClass: "wrapped",
        headerName: 'Type',
        headerTooltip: 'Type',
        field: 'name',
        tooltipField: 'name',
        minWidth: 125,
        maxWidth: 125
    };

    columnStatus: ColDef = {
        headerClass: "wrapped",
        headerName: 'Status',
        headerTooltip: 'Status',
        field: 'status',
        tooltipValueGetter: this.statusFormatter(this),
        valueGetter: this.statusFormatter(this),
        minWidth: 100
    };

    columnRecorder: ColDef = {
        headerClass: "wrapped",
        headerName: "Recorder",
        headerTooltip: "Recorder",
        field: "userName",
        tooltipField: "userName",
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatter.defaultTextFilterParams,
        minWidth: 150,
        maxWidth: 200
    } as ColDef;

    ownerTypeColumn: ColDef = {
        headerClass: "wrapped",
        headerName: "Owner Type",
        headerTooltip: "Owner Type",
        tooltipValueGetter: this.formatOwnerType(),
        valueGetter: this.formatOwnerType(),
        minWidth: 110
    }


    data: PendingFlow[];

    externalColumns = [
        this.columnDateSubmitted,
        this.columnExternalApplicationNumber,
        this.columnFlowName,
        this.columnCreatedBy,
        this.columnStatus
    ];

	gridOptions: GridOptions;
	gridApi?: GridApi;

    public internalColumns: ColDef[]  = [
        this.columnCompany,
        this.ownerTypeColumn,
        this.columnInternalApplicationNumber,
        this.columnFlowLink,
        this.columnDateSubmitted,
        this.columnStatus,
        this.columnRecorder,
        {
            headerClass: "wrapped",
            headerName: "Assignee",
            headerTooltip: "Assignee",
            tooltipField: "assignedUserId",
            field: "assignedUserId",
            suppressFiltersToolPanel: true,
            suppressMovable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
                formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                values: this.filteredUsers
            },
            cellRenderer: this.renderAssignedUser,
            valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
            filterValueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId)?.displayName ?? 'Unassigned',
            valueSetter: this.assign,
            tooltipValueGetter: this.renderAssignedUser,
            onCellValueChanged: this.cellValueChanged,
            minWidth: 100
        },
    ];

    statusEnum = WorkOrderStatus;
    templateIds = FinancialAssuranceService.TemplateIds;

    constructor(
        private formatterService: GridFormatterService,
        public service: WorkOrderService,
        private router: Router,
        private auth: AuthService,
        public groupService: GroupService,
        private flowInstanceService: FlowInstanceService,
        private gridFormatter: GridFormatterService,
        public workOrderService: WorkOrderService,
    ) {
        super("ViewFinancialAssuranceInternalWidget", [LunaClaimValues.ViewFinancialAssuranceInternalWidget]);

    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    ngOnInit() {
        this.refreshData();
        this.setGridOptions();
        
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    formatOwnerType(): any {
        return (obj: any) => {
            let returnValue: string = "";
            if (obj.data != null && obj.data["organizationId"] != null && this.complianceData != null) {
                let organizationId = obj.data["organizationId"];
                let compliance = this.complianceData.find(c => c.orgId == organizationId);
                if (compliance != null) {
                    if (compliance.isBrineHauler != null) {
                        if (compliance.isBrineHauler == true) returnValue = "Brine Hauler";
                    }
                    if (compliance.isWellOwner != null) {
                        if (compliance.isWellOwner == true) {
                            if (returnValue.length > 0) {
                                returnValue += ", ";
                            }
                            returnValue += "Well Owner";
                        }
                    }
                }

            }
            if (returnValue.length === 0) returnValue = "N/A";
            return returnValue;
        }
    }

    refreshData(): void {
        let subs$ = this.getDataObs$().pipe(
            tap((data: PendingFlow[]) => {
                if (this.isInternal) {
                    let permissionedGroups = this.groups.filter(g => this.groupHasPermission(g));
                    this.filteredUsers = this.buildUserList(permissionedGroups);
                }
                this.data = data;
                this.data = data.sort((a, b) => a.dateSubmitted > b.dateSubmitted ? 1 : -1);
            })
        ).subscribe(
            () => {
				if (this.gridApi != null) {
                    this.gridApi.setGridOption("columnDefs", []);
				    this.gridApi.setGridOption("columnDefs", this.buildColumns());
                }
                this.resizeColumns();
            }, (error) => {
                console.error(error);
        });
        this.subscriptions.add(subs$);
    }

    resizeColumns(): void {
        if (this.gridApi) {
            setTimeout(() => this.gridApi?.sizeColumnsToFit(), 0);
        }
    }

    statusFormatter(component: any) {
        return (obj: any) => 'Pending';
    }

    assign(params: any): any {
        let result: boolean = false;
        if (params && params.newValue && params.newValue.id) {
            if (params.newValue.id != "-1") {
                params.data.assignedUserId = params.newValue.id;
            } else {
                params.data.assignedUserId = "";
            }

            if (params.context && params.context.componentParent) {
                let parent = <FinancialAssurancePendingComponent>params.context.componentParent;
                let selectedItem = parent.allUsers.find(u => u.id == params.newValue.id);
                if (selectedItem) {
                    params.data.assignedUserName = selectedItem.displayName;
                }
            }
            result = true;
        }
        return result;
    }

    buildColumns(): ColDef[] {
        let columns: ColDef[] = [];
        if (this.isInternal) {
            columns.push(this.columnCompany);
            columns.push(this.ownerTypeColumn);
            columns.push(this.columnInternalApplicationNumber);
            columns.push(this.columnFlowLink);
            columns.push(this.columnDateSubmitted);
            columns.push(this.columnStatus);
            columns.push(this.columnRecorder);
            columns.push({
                headerClass: "wrapped",
                headerName: "Assignee",
                headerTooltip: "Assignee",
                tooltipField: "assignedUserId",
                field: "assignedUserId",
                suppressFiltersToolPanel: true,
                suppressMovable: true,
                editable: true,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorPopup: true,
                cellEditorParams: {
                    formatValue: (value: any) => value?.displayName ?? 'Unassigned',
                    values: this.filteredUsers
                },
                cellRenderer: this.renderAssignedUser,
                valueGetter: (params) => this.allUsers.find(u => u.id === params.data?.assignedUserId) ?? null,
                valueSetter: this.assign,
                tooltipValueGetter: this.renderAssignedUser,
                onCellValueChanged: this.cellValueChanged,
                minWidth: 100
            });
        } else {
            columns = this.externalColumns;
        }

        this.formatterService.applyFilterKeyboardHintTooltips(columns);
        return columns;

    }

    canApprove(obj: any): boolean {
        let res: boolean = false;
        if (obj != null && obj.data != null) {
            let data: PendingFlow = <PendingFlow>obj.data;
            res = this.auth.User.groups.findIndex(g => g === data.assignedGroupId) != -1;
        }
        return res;
    }

    cellValueChanged(params: any): void {
        if (params.api) {
            params.api.refreshCells();
        }
    }

    getDataObs$(): Observable<PendingFlow[]> {
        const spec = {
            organizationId: this.orgId,
            templateIds: this.templateIds,
            types: [WorkOrderType.Review],
            statuses: [WorkOrderStatus.Pending]
        } as WorkOrderSearchSpec;
        let allUserSearchObs$ = this.groupService.get({ internal: true, stubs: false, fullContactDetails: true } as GroupSearchSpec);
        let pendingSearchObs$ = this.service.getPendingFlows(spec, false).pipe(
           
        );

        let obs$: Observable<PendingFlow[]>;
        if (this.isInternal) {
            obs$ = allUserSearchObs$.pipe(tap((groupData) => {
                this.allUsers = [];
                this.filteredUsers = [];
                if (groupData != null) {
                    if (groupData instanceof Array) {
                        this.groups = groupData as Group[];
                        this.groups.forEach(g => this.allUsers = this.allUsers.concat(g.users));
                    }
                    this.allUsers = this.filterUniqueUsers(this.allUsers);
                    this.allUsers.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);
                }
            }),
                switchMap((data) => {
                    return pendingSearchObs$;
                })
            );
        }
        else {
            obs$ = pendingSearchObs$;
        }

        return obs$;
    }

   
    buildUserList(groups: Group[]): ContactStub[] {
        let userList: ContactStub[] = [];
        groups.forEach(u => userList = userList.concat(u.users));
        userList = this.filterUniqueUsers(userList);
        userList = this.sortUsers(userList);
        userList.unshift({ id: "-1", displayName: "Unassigned" } as ContactStub);        
        return userList;
    }

    filterUniqueUsers(users: ContactStub[]): ContactStub[] {
        return users.filter((user, i, arr) => arr.findIndex(t => t.id === user.id) === i);
    }   

    renderUserDropdownOptions(params: any): string {
        let returnValue = params && params.value && params.value.displayName ? params.value.displayName : "Unassigned";
        return returnValue;
    }

    renderAssignedUser(params: any): string {
        let returnValue: string = "Unassigned";
        if (params && params.data && params.data.assignedUserId && params.data.assignedUserName) {
            returnValue = params.data.assignedUserName;
        }
        return returnValue;
    }

    saveAssignments(event: any): void {
        let changedItem = <PendingFlow>event.data;
        if (event.context && event.context.componentParent) {
            const component = <FinancialAssurancePendingComponent>event.context.componentParent;
            const pending = new PendingWorkOrderAssignment(changedItem.currentWorkItemId, changedItem.assignedUserId, changedItem.assignedUserName, true, changedItem.flowId);
            let updateSubs$ = component.workOrderService.assignWorkOrder(pending).pipe()
                .subscribe({
                    next: (result) => { console.log("update managed"); },
                    error: (error) => { console.error(error); }
                });
                    
            component.subscriptions.add(updateSubs$);
        }
    }

    setGridOptions(): void {
        this.gridOptions = <GridOptions>{
            columnDefs: this.buildColumns(),
            context: {
                componentParent: this
            },
            defaultColDef: { filter: true, resizable: true, sortable: true, editable: true } as ColDef,
            headerHeight: 50,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            onCellValueChanged: ($event) => this.saveAssignments($event),
            pagination: true,
            paginationAutoPageSize: true,
			suppressHorizontalScroll: false,
			onGridReady: (params) => { this.gridApi = params.api; }
        };
    }

    showLoadingOverlays(show: boolean): void {
        if (this.gridApi) {
            if (show) {
				this.gridApi.setGridOption("rowData", []);
                this.gridApi.setGridOption("loading", true);
            } else
                this.gridApi.setGridOption("loading", false);
        }
    }

    sortUsers(users: ContactStub[]): ContactStub[] {
        return users.sort((a, b) => {
            if (a.firstName > b.firstName) return 1;
            if (a.firstName < b.firstName) return -1;
            if (a.firstName == b.firstName) {
                if (a.lastName > b.lastName) return 1;
                if (a.lastName < b.lastName) return -1;
            }
            return 0;
        })
    }
}
